<template>
  <div class="center" style="padding:25px 10px 65px; width: 100%;">
    <h2 class="pb-2 text-center juliazhao">Contact</h2>
    <v-layout row justify-center>

      <v-card flat max-width="400">
        <div>
          <p><i class="fa fa-phone"></i>&nbsp;&nbsp;626-390-8870</p>
          <p><i class="fa fa-envelope"></i>&nbsp;&nbsp;juliazhao@remax.net</p>
          <p>RE/MAX Elite Realty<br/>842 E. Valley Blvd, Alhambra, CA 91801</p>
        </div>
        <div style="min-height:450px;">
          <v-form v-model="valid">
            <v-text-field
              id="name"
              v-model="name"
              :rules="[rules.required]"
              label="Your name *"
              required
            ></v-text-field>

            <v-text-field
              id="email"
              v-model="email"
              :rules="[rules.required]"
              label="Your email address *"
              required
            ></v-text-field>
            <v-text-field
              id="phone"
              v-model="phone"
              :rules="[rules.required]"
              label="Your phone number *"
              required
            ></v-text-field>
            <v-textarea id="message" v-model="message"
                        auto-grow
                        label="Your message *"
                        :rules="[rules.required]"
                        required
                        rows="1">

            </v-textarea>
            <v-btn light @click="submit">Send Message</v-btn>
          </v-form>
          <p style="color:green">{{success}}</p>
          <p style="color:red">{{err}}</p>
        </div>
      </v-card>

    </v-layout>
  </div>
</template>

<script>
import contact from '../contact'

  export default {
    name: "contact",
    data() {
      return {
        valid: true,
        name: null,
        email: null,
        phone: null,
        message: null,
        rules: {
          required: value => !!value || ' '
        },
        success: '',
        err: ''
      }
    },
    methods: {
      submit(){
        let my = this
        contact.post('http://juliazhao.com/realestate/contact.php', {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
        }, function (resp) {
          if(resp.status===200 && resp.data === 'success') {
            my.success = 'Your message has been sent.'
          } else {
            my.err = 'Message could not be sent. Please check all fields and try again.'
          }
        }, function (err) {
          my.err = err.message?err.message:err
        })
      }
    }
  }

</script>

<style scoped>

</style>
